import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CommonService } from '../../services/commonService';

export const Unsubscribe = () => {
  const { email } = useParams();
  const decodedEmail = decodeURIComponent(email);

  const [status, setStatus] = useState('loading');

  useEffect(() => {
    CommonService.unsubscribe(decodedEmail)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [decodedEmail]);

  return (
    <main>
      <article className="a-completed">
        <section className="section-info">
          {status === 'loading' && <p>Procesando...</p>}
          {status === 'success' && (
            <>
              <i className="bi bi-check-circle bi-class-okay"></i>
              <h1>Cancelación exitosa</h1>
              <p>El email <strong>{decodedEmail}</strong> fue dado de baja correctamente.</p>
            </>
          )}
          {status === 'error' && (
            <>
              <i className="bi bi-x-circle"></i>
              <h1>Ocurrió un error</h1>
              <p>No fue posible procesar la solicitud. Por favor intentá nuevamente.</p>
            </>
          )}
        </section>
      </article>
    </main>
  );
};
